import React from 'react';
import { useField, useFormikContext } from 'formik';
import Error from './FormItemError';
import Input from '../components/Input';
import FieldProps from './FieldProps';
import Label from '../components/Label';
import './FormikStyles.less';
import { SizeType } from 'antd/lib/config-provider/SizeContext';

export interface InputProps extends FieldProps {
  size?: any;
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>;
  disabled?: boolean;
  defaultValue?: string;
  value?: string;
  hint?: string;
  prefix?: string;
  maxLength?: number;
  type?: string;
  min?: string | number;
  max?: string | number;
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined;
}

const FormikDefaultInputField: React.FC<InputProps> = (props) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const showError = meta.touched && meta.error;
  const error = showError ? <Error>{meta.error}</Error> : <Error></Error>;
  const id = props.id || props.name;

  const onChange = (e: any) => {
    setFieldValue(props.name, e.target.value);

    if (props.onChange) props.onChange(e);
  };

  const hint = props.hint ? (
    <span className="formik-field__span"> {props.hint}</span>
  ) : null;

  return (
    <>
      <Label htmlFor={id} className=" no-select hand-on-hover">
        {props.label}
        {hint}
      </Label>
      <Input
        {...field}
        {...props}
        className={`${props.className} `}
        id={id}
        onChange={onChange}
        defaultValue={props.defaultValue}
      />
      {error}
    </>
  );
};

export default FormikDefaultInputField;
